import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';

/**
 * EntitiesMore component
 * Similar to TagsMore but for entity lists with a default limit of visible items
 */
export default class EntitiesMore extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'EntitiesMore',
    refs: ['btn'],
    options: {
      limit: {
        type: Number,
        default: 4,
      },
    },
  };

  isClosed = true;

  items = [];

  /**
   * mounted
   */
  mounted() {
    // Find items using querySelectorAll since they're nested inside another element
    this.items = Array.from(this.$el.querySelectorAll('[data-ref="item"]'));

    const totalItems = this.items.length;
    const hasMore = totalItems > this.$options.limit;

    toggleClass(this.$el, 'is-overflowing', hasMore);

    if (this.$refs.btn) {
      this.$refs.btn.style.visibility = hasMore ? 'visible' : 'hidden';
    }

    // Hide items beyond the limit
    if (hasMore) {
      this.toggleItemsVisibility(true);
    }
  }

  /**
   * Toggle visibility of items beyond the limit
   * @param {boolean} hide Whether to hide the extra items
   */
  toggleItemsVisibility(hide) {
    this.items.forEach((item, index) => {
      if (index >= this.$options.limit) {
        item.style.display = hide ? 'none' : '';
      }
    });
  }

  /**
   * onBtnClick
   */
  onBtnClick() {
    // Captured before hiding items: `display: none` forces a synchronous
    // blur to <body>, so checking activeElement after the fact can never
    // tell whether focus was inside this component.
    const hadFocusInside = this.$el.contains(document.activeElement);

    this.isClosed = !this.isClosed;
    this.toggleItemsVisibility(this.isClosed);
    toggleClass(this.$el, 'is-open', !this.isClosed);
    this.$refs.btn.setAttribute('aria-expanded', String(!this.isClosed));

    if (this.isClosed) {
      if (hadFocusInside) {
        this.$refs.btn.focus();
      }
    } else {
      const firstNewItem = this.items[this.$options.limit];
      if (firstNewItem) {
        const focusTarget = firstNewItem.querySelector('a, button') ?? firstNewItem;
        if (focusTarget === firstNewItem && !focusTarget.hasAttribute('tabindex')) {
          focusTarget.setAttribute('tabindex', '-1');
        }
        focusTarget.focus();
      }
    }
  }
}
